import {atomWithStorage} from 'jotai/utils';

// Table row density for workstreams_v2 (persisted to localStorage)
export const workstreamTableDensityAtom = atomWithStorage<'compact' | 'comfortable'>(
  'workstreams-v2-table-density',
  'compact'
);

// Recent selections from sidebar People search (persisted to localStorage)
export const peopleSearchRecentsAtom = atomWithStorage<
  Array<{user_id: string; ldap: string; name: string; profile_photo_url?: string | null}>
>('workstream-people-search-recents', [], undefined, {getOnInit: true});
